<template>
	<router-view />
</template>
<script>
    export default {
        name: "parent.vue"
    }
</script>
<style scoped></style>